import { Loader, icons } from '@lifebit-ai/lds'
import { ResultsState } from 'enums'
import React from 'react'

import { isRetrySupported } from 'modules/requests/utils'
import type { Result } from 'services/results/types'
import { formatDate } from 'utils/date'

import * as styles from './ResultFailureAlert.styles'

export const RETRY_APPROVE_RESULT_BUTTON_TEST_ID = 'retry-approve-result-button-test-id'

interface ResultFailureAlertProps {
  result: Result
  onClickRetry: (e: React.MouseEvent<HTMLButtonElement>) => void
  isRetrying: boolean
  isRetryingDisabled: boolean
}

export const ResultFailureAlert: React.FC<ResultFailureAlertProps> = ({
  result,
  onClickRetry,
  isRetrying,
  isRetryingDisabled
}) => {
  if (result.status === ResultsState.Rejected) {
    return (
      <styles.StyledAlert type="danger" showIcon data-testid="rejected-alert">
        {`The request was rejected on ${formatDate(result.verifiedAt)} by ${result.verifiedBy?.email}, with a note: "${
          result.rejectionReason
        }"`}
      </styles.StyledAlert>
    )
  }

  if (result.status === ResultsState.Failed) {
    return (
      <styles.StyledAlert type="danger" showIcon data-testid="failed-alert">
        <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span>{result.failureReason || 'Failed to export data'}</span>

          {isRetrySupported(result) && (
            <styles.StyledButton
              type="primary"
              onClick={onClickRetry}
              data-testid={RETRY_APPROVE_RESULT_BUTTON_TEST_ID}
              disabled={isRetrying || isRetryingDisabled}
            >
              {isRetrying ? <Loader text={false} /> : <icons.RedoSmall />}
              <span>Retry</span>
            </styles.StyledButton>
          )}
        </div>
      </styles.StyledAlert>
    )
  }

  return null
}
